import type { BookingDetailsNextPaymentType, BookingDetailsPayment } from '../../domain/types'
import type { BookingDetailsPaymentAPIResponse } from '../types'

export function paymentMapper(payment?: BookingDetailsPaymentAPIResponse | null): BookingDetailsPayment | null {
  if (!payment || payment.totalAmount == null || payment.amountPaid == null || !payment.status)
    return null

  const nextPayment = payment.nextPayment

  return {
    totalAmount: payment.totalAmount,
    amountPaid: payment.amountPaid,
    refundAmount: payment.refundAmount ?? null,
    status: payment.status as BookingDetailsPayment['status'],
    isPaymentEnabled: payment.isPaymentEnabled ?? false,
    hasDownPayment: payment.hasDownPayment ?? false,
    nextPayment: nextPayment && nextPayment.amount != null && nextPayment.amount > 0 && nextPayment.paymentURL?.trim()
      ? {
          type: nextPayment.type as BookingDetailsNextPaymentType ?? '',
          amount: nextPayment.amount,
          dueDate: nextPayment.dueDate ?? '',
          paymentURL: nextPayment.paymentURL,
        }
      : null,
  }
}
